var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"toolbarOption":_vm.toolbarOption,"tool":_vm.tool.name,"active":_vm.tool.active,"tag":_vm.tool.tag,"value":_vm.tool.value,"option":_vm.tool.option},on:{"setValue":_vm.setToolValue,"setOption":_vm.setToolOption,"setActive":_vm.setToolActive}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }